export default class ServiceCall {
    ipAddress: string = '';
}
